import { makeRequest } from 'cityads-v3/utils/apiUtils';

export const CLEAR_FILTERS = 'monitoring/CLEAR_FILTERS';
export const DELETE_FILTER = 'monitoring/DELETE_FILTER';
export const DELETE_FILTER_ITEM = 'monitoring/DELETE_FILTER_ITEM';
export const REPLACE_FILTERS = 'monitoring/REPLACE_FILTERS';
export const SET_APPLIED_FILTER = 'monitoring/SET_APPLIED_FILTER';
export const SET_CURRENCY_ID = 'monitoring/SET_CURRENCY_ID';
export const SET_FILTER = 'monitoring/SET_FILTER';
export const SET_FILTER_AND_APPLY = 'monitoring/SET_FILTER_AND_APPLY';

export const GET_ALERTS_TOTAL = 'monitoring/GET_ALERTS_TOTAL';
export const GET_ALERTS_TOTAL_SUCCESS = 'monitoring/GET_ALERTS_TOTAL_SUCCESS';
export const GET_ALERTS_TOTAL_FAIL = 'monitoring/GET_ALERTS_TOTAL_FAIL';

export const GET_ALERTS_TOTAL_UNVIEWED = 'monitoring/GET_ALERTS_TOTAL_UNVIEWED';
export const GET_ALERTS_TOTAL_UNVIEWED_SUCCESS = 'monitoring/GET_ALERTS_TOTAL_UNVIEWED_SUCCESS';
export const GET_ALERTS_TOTAL_UNVIEWED_FAIL = 'monitoring/GET_ALERTS_TOTAL_UNVIEWED_FAIL';

export const SET_VIEWED = 'monitoring/SET_VIEWED';
export const SET_VIEWED_SUCCESS = 'monitoring/SET_VIEWED_SUCCESS';
export const SET_VIEWED_FAIL = 'monitoring/SET_VIEWED_FAIL';

export const SEND_COMMENT = 'monitoring/SEND_COMMENT';
export const SEND_COMMENT_SUCCESS = 'monitoring/SEND_COMMENT_SUCCESS';
export const SEND_COMMENT_FAIL = 'monitoring/SEND_COMMENT_FAIL';

export function getAlertsTotal(body) {
  return makeRequest('/saduka/monitoring/alerts/count', {
    types: [GET_ALERTS_TOTAL, GET_ALERTS_TOTAL_SUCCESS, GET_ALERTS_TOTAL_FAIL],
    options: {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    },
  });
}

export function getAlertsTotalUnviewed(body) {
  return makeRequest('/saduka/monitoring/alerts/count', {
    types: [GET_ALERTS_TOTAL_UNVIEWED, GET_ALERTS_TOTAL_UNVIEWED_SUCCESS, GET_ALERTS_TOTAL_UNVIEWED_FAIL],
    options: {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...body, is_viewed: false })
    },
  });
}

export function setFilter(name, value) {
  return {
    type: SET_FILTER,
    name,
    value
  }
}

export function deleteFilter(name) {
  return {
    type: DELETE_FILTER,
    name,
  }
}

export function deleteFilterItem(name, value) {
  return {
    type: DELETE_FILTER_ITEM,
    name,
    value
  }
}

export function setCurrencyId(value) {
  return {
    type: SET_CURRENCY_ID,
    value
  }
}

export function replaceFilters(filters) {
  return {
    type: REPLACE_FILTERS,
    filters
  }
}

export function clearFilters(filters) {
  return {
    type: CLEAR_FILTERS,
    filters
  }
}

export function setAppliedFilter() {
  return {
    type: SET_APPLIED_FILTER,
  }
}

export function setFilterAndApply(filter) {
  return {
    type: SET_FILTER_AND_APPLY,
    filter
  }
}

export function toggleIsNew(id, isNew = true) {
  return makeRequest(`/saduka/monitoring/alerts/viewed/${id}`, {
    types: [SET_VIEWED, SET_VIEWED_SUCCESS, SET_VIEWED_FAIL],
    options: {
      method: isNew ? 'DELETE' : 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
    }
  });
}

export function sendComment(id, comment) {
  return makeRequest(`/saduka/monitoring/alerts/comment/${id}`, {
    types: [SEND_COMMENT, SEND_COMMENT_SUCCESS, SEND_COMMENT_FAIL],
    options: {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ comment })
    }
  });
}
